import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../utils/cn';
export const HamburgerIcon = ({ isDarkSurface }) => {
    const barColor = isDarkSurface ? 'bg-static' : 'bg-static-inverse';
    return (_jsxs("span", { className: "relative block h-4 w-4", "aria-hidden": "true", children: [_jsx("span", { className: cn(barColor, 'absolute inset-x-0 top-1/2 block h-[1.5px] translate-y-[-3.5px]') }), _jsx("span", { className: cn(barColor, 'absolute inset-x-0 top-1/2 block h-[1.5px] translate-y-[3.5px]') })] }));
};
